module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.row.start.award_show_type == 2) ? _c('ScoreAwardOne', {
    attrs: {
      "row": _vm.row.start,
      "list": _vm.row.list,
      "start": _vm.row.start.subject
    }
  }) : _vm._e(), _vm._v(" "), (_vm.row.start.award_show_type == 1) ? _c('ScoreAwardList', {
    attrs: {
      "row": _vm.row.start,
      "list": _vm.row.list,
      "start": _vm.row.start.subject
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e3bf541","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/score/ScoreShow3.vue
// module id = 2503
// module chunks = 0